import { Box, Typography } from '@mui/material';
import { ErrorOutline } from '../../../../../icons/error-outline';
import { style } from './style';

type CandidatePromoteStateErrorProps = {
  promoteErrorMessage: string,
}

export const CandidatePromoteStateError = ({
  promoteErrorMessage,
}: CandidatePromoteStateErrorProps):JSX.Element => {
  return (
    <Box sx={ style.Box.sx }>
      <ErrorOutline fill="none" />
      <Typography
        sx={ style.Typography.sx }
        variant="body1"
      >
        {promoteErrorMessage}
      </Typography>
      <Box className="error-tooltip">
        <Box>
          {promoteErrorMessage}
        </Box>
      </Box>
    </Box>
  );
};
